var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.369,
    height: 43.369,
    viewBox: "0 0 43.369 43.369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BT_Plus_Blue",
    "data-name": "BT Plus Blue",
    transform: "translate(0 21.821) rotate(-45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_8",
    "data-name": "Linha 8",
    x2: 30.86,
    transform: "translate(0 15.237)",
    fill: "none",
    stroke: "#7e91b5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_9",
    "data-name": "Linha 9",
    x2: 30.474,
    transform: "translate(15.623) rotate(90)",
    fill: "none",
    stroke: "#7e91b5",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/closeModal.04b7300f8ec55a5f0da2258d471f92c6.svg";
export { ForwardRef as ReactComponent };